export * from './polyfills';
export * from './vendor';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';

import { AppModule } from './app.module';

//if (process.env.ENV === 'production') {
//    enableProdMode();
//}

platformBrowserDynamic().bootstrapModule(AppModule);


// WEBPACK FOOTER //
// ./app/main.ts